import { defaultFlowSteps, DownloadAppsStepInfo, InviteLinkShareStepInfo } from '@/components/Steps';
import { FlowModel } from '@/models/flow.model';
import { getStore } from '@/redux/store';
import { CompanyTrackingMode } from '@/types/company.type';
import { DefaultStepsInfo } from '@/types/steps.type';

export class DefaultFlowModel implements FlowModel {
  private _trackingMode: CompanyTrackingMode | undefined;
  private _steps: DefaultStepsInfo[] = defaultFlowSteps();
  readonly category = 'Onboarding';
  readonly name = 'default';
  readonly onboardingCompleteStep = 'Completed Onboarding';
  readonly onboardingCompleteEvent = 'Onboard Complete';
  readonly showSpecialOffer = true;
  _whoOwnsComputer: string | null = null;
  private _isUEMember = false;

  get trackingMode(): CompanyTrackingMode | undefined {
    return this._trackingMode;
  }

  set trackingMode(value: CompanyTrackingMode | undefined) {
    this._trackingMode = value;
  }

  getSteps = () => {
    const state = getStore().getState();
    const inviteVariant = state.onboarding.inviteOptimizationResolved;

    let allSteps = defaultFlowSteps();

    if (inviteVariant === 'C') {
      const idx = allSteps.findIndex(step => step.id === 'sendInvitesStep');
      if (idx !== -1) {
        allSteps = [...allSteps.slice(0, idx + 1), InviteLinkShareStepInfo, ...allSteps.slice(idx + 1)];
      }
    }

    // Always include trackingModeStep if it's currently active
    const includeTrackingModeStep =
      state.onboarding.currentStep?.id === 'trackingModeStep';


    if (this._isUEMember) {
      // For EU members, exclude both trackingModeStep and computerOwnerStep
      // unless they are currently active
      return allSteps.filter(step =>
        (step.id !== 'trackingModeStep' || includeTrackingModeStep));
    }

    return allSteps;
  };
  useShortenedFlow(): void {
    // silent is golden
  }

  addDownloadAppStep() {
    this._steps.push(DownloadAppsStepInfo);
  }

  setCompanySize() {
    // silent is golden
  }

  setWhoOwnsComputer(computerOwner: string) {
    this._whoOwnsComputer = computerOwner;
  }


  setUEMemberStatus(isMember: boolean) {
    this._isUEMember = isMember;
  }

  removeStepById(stepId: string) {
    const allSteps = defaultFlowSteps();
    return allSteps.filter(step => step.id !== stepId);
  }
}

export const defaultFlowModel = new DefaultFlowModel();
